import { createSlice } from "@reduxjs/toolkit";
import { getOrders } from "../../reduxApi/admin/OrdersReduxApi";

const OrdersSlice = createSlice({
  name: "orders",
  initialState: {
    status: "idle",
    isFiltered: false,
    orders: [],
  },
  reducers: {
    setFilteredStatus: (state, action) => {
      state.isFiltered = action.payload;
    },
    deleteOrdersAction: (state, action) => {
      state.orders = state.orders.filter(
        (item) => !action.payload.includes(item?.orders?.ROWID),
      );
    },
    updateOrdersAction: (state, action) => {
      const index = state.orders.findIndex(
        (item) => item.orders.ROWID === action.payload.ROWID,
      );
      if (index !== -1) {
        state.orders[index] = { orders: action.payload };
      }
    },
    addOrdersAction: (state, action) => {
      const temp = action.payload.formData;
      temp.ROWID = action.payload.ROWID;
      state.orders.unshift(temp);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrders.pending, (state, action) => {
        state.status = "pending";
      })
      .addCase(getOrders.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.orders = action.payload.data.orders;
      });
  },
});

export const { deleteOrdersAction, updateOrdersAction, addOrdersAction, setFilteredStatus } =
  OrdersSlice.actions;
export default OrdersSlice.reducer;
